<template>
  <div class="app-container">
    <list ref="list" :is-show="isShow" :can-price="canPrice">
      <template slot="toolbar-right">
        <template v-if="$permission.canFinish()">
          <el-button type="success" @click="finish">完成订单</el-button>
        </template>
        <template v-if="$permission.canWrite()">
      <!--    <el-button type="info" @click="onPrintTemaplate">打印模板</el-button>-->
          <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
          <el-button type="danger" @click="delRows">删除</el-button></template
        >
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" v-if="isShow" :width="100">
          <template slot-scope="{ row }">
            
            <template v-if="row.Status < 2">
              <template v-if="$permission.canWrite()">
                <el-button type="text" @click.stop="edit(row)">编辑</el-button>
              </template>
            </template>
           
            <el-button type="text" v-if="row.Status >= 2" @click.stop="details(row)">查看</el-button>
             <el-button type="text" @click="onPrint(row)">打印</el-button>
            <el-button v-if="!isShow" type="text" @click="select(row)">选择</el-button>
          </template>
        </el-table-column>
      </template></list
    >
    <!-- <edit-dialog ref="editDialog" @close-saved="reload" /> -->
  </div>
</template>
<script>
import curdMixins from '@/mixins/trend/curd'
import list from '@/components/business/sales/saleorder/list'
// import editDialog from "@/components/business/purchase/inquiry/editDialog";

export default {
  name: 'saleorder',
  mixins: [curdMixins],
  components: {
    list
    // editDialog,
  },
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      params: {
        RankName: '',
        Status: null
      }
    }
  },
  activated() {
    this.getRouterInfo()
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice()
    }
  },
  methods: {
    finish() {
      let rows = this.$refs.list.getCheckedRows()
      if (rows.length == 0) {
        this.$message.warning('请选择要操作的数据')
        return
      }
      this.$confirm('确认操作所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let ids = rows.map(item => {
            return item.OrderId
          })
          this.$refs.list.finishRange(ids)
        })
        .catch(() => {})
    },
    onPrint2(row) {
      var url = location.origin + '/#/customprintview/销售订单/' + row.OrderId
      window.open(url, '_blank')
    },

   onPrint(row) {
      let newpage = this.$router.resolve({
        path: "/saleorderPrint?id=" + row.OrderId,
      });
      window.open(newpage.href, "_blank");
    },

    onPrintTemaplate() {
      var url = location.origin + '/#/customprint/' + '销售订单'
      window.open(url, '_blank')
    },
    getRouterInfo() {
      // console.log(this.$router.history.current.params);
      if (this.$router.history.current.params) {
        this.$refs.list.tempParams.SourceDocNo = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.SourceDocNo
        }
        this.$refs.list.tempParams.OrderNo = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.OrderNo
        }
        this.$refs.list.tempParams.SourceType = {
          paramValueType: 'resetParamValue',
          isReset: true,
          value: this.$router.history.current.params.SourceType
        }
        // this.params.SourceType=this.$router.history.current.params.SourceType
        // this.$refs.list.getData()
        this.params = {}
      }
    },
    // path:"/business/purchase/inquiry"
    create() {
      this.$router.push({ name: 'editSaleOrder', params: { mode: 'create' } })
    },
    edit(data) {
      this.$router.push({ name: 'editSaleOrder', params: { mode: 'edit', data } })
    },
    details(data) {
      this.$router.push({ name: 'editSaleOrder', params: { mode: 'details', data } })
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows()
      if (rows.length == 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('确认删除所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let ids = rows.map(item => {
            return item.OrderId
          })
          this.$refs.list.delRange(ids)
        })
        .catch(() => {})
    },
    select(row) {
      this.$emit('get-select', row)
    }
  }
}
</script>